const trackers = [...document.body.querySelectorAll('.js-analytics')];

function trackingParams(key) {
  const obj = {
    mainNav_tracking: {
      actionText: 'mainNav_action',
      labelText: 'mainNav_label',
    },
    footer_tracking: {
      actionText: 'footer_action',
      labelText: 'footer_label',
    },
    engagedActions_tracking: {
      actionText: 'engagedActions_action',
      labelText: 'engagedActions_label',
    },
    cta_tracking: {
      actionText: 'cta_action',
      labelText: 'cta_label',
    },
    newsFilter_tracking: {
      actionText: 'newsFilter_action',
      labelText: 'newsFilter_label',
    },
  };

  return obj[key];
}

function trackEvent(category, action, label) {
  if ((!category) || (!action) || (!label)) {
    return;
  }

  const {
    actionText,
    labelText,
  } = trackingParams(category);

  dataLayer.push({
    event: category,
    [actionText]: action,
    [labelText]: label,
  });
}

function trackPage(label) {
  const vpUrl = `/virtual/${label.toLowerCase().replace(/\s+/g, '-')}/submit`;
  const vpvLabel = `Virtual - ${label} - Submit`;

  dataLayer.push({
    'event': 'virtualPageview',
    'virtualPageURL': vpUrl,
    'virtualPageTitle': vpvLabel
  });
}

function processTracking(event) {
  if (!window.ga) {
    return;
  }

  let {
    gaFunction,
    gaCategory,
    gaAction,
    gaLabel,
    gaVpvLabel
  } = event.target.dataset;

  if (gaFunction !== 'virtual') {
    // If PDF download, adjust action and label
    const regex = /(?:\.([^.]+))?$/;
    const extension = regex.exec(event.target.href)[1];
    if (extension === 'pdf') {
      const filename = event.target.href.split("/").pop();
      gaCategory = 'engagedActions_tracking';
      gaAction = 'Download';
      gaLabel = filename;
    }
    
    // If external link, adjust action
    if (event.target.target === "_blank") {
      gaCategory = 'engagedActions_tracking';
      gaAction = 'External Link';
      gaLabel = event.target.href;
    }

    // If CTA action, adjust Label
    if (gaCategory === 'cta_tracking') {
      const bodyScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const ctaLocation = Math.round(event.target.getBoundingClientRect().top + bodyScrollTop);
      gaAction = `${ctaLocation}px + ${event.target.text}`;
      gaLabel = event.target.href;
    }
  }

  if (gaFunction === 'multi') {
    trackEvent(gaCategory, gaAction, gaLabel);
    trackPage(gaVpvLabel);
  } else if (gaFunction === 'event') {
    trackEvent(gaCategory, gaAction, gaLabel);
  } else if (gaFunction === 'virtual') {
    trackPage(gaVpvLabel);
  }
}

function init() {
  if (!trackers.length) {
    return;
  }

  for (let i = 0; i < trackers.length; i += 1) {
    trackers[i].addEventListener('click', processTracking);
  }
}

export default init;



// WEBPACK FOOTER //
// ./src/scripts/mando-lib.analytics.js